<!-- Task Assignee Picker - Selecteur d'assignes multi-selection -->
<div
  class="task-assignee-picker"
  [class.task-assignee-picker--open]="isOpen"
  [class.task-assignee-picker--disabled]="disabled"
>
  <!-- Field trigger -->
  <div
    class="task-assignee-picker__field"
    tabindex="0"
    role="button"
    [attr.aria-label]="placeholder"
    [attr.aria-expanded]="isOpen"
    (click)="toggle()"
    (keydown)="onFieldKeyDown($event)"
  >
    <!-- Chips des sélectionnés -->
    <div class="task-assignee-picker__chips" *ngIf="assignees.length > 0">
      <span *ngFor="let assignee of assignees" class="task-assignee-picker__chip" (click)="$event.stopPropagation()">
        <span class="task-assignee-picker__chip-avatar" [style.background-color]="assignee.badge_color || '#BEBEBE'">
          {{ assignee.initials || getInitials(assignee.name) }}
        </span>
        <span class="task-assignee-picker__chip-name">{{ assignee.name }}</span>
        <button
          type="button"
          class="task-assignee-picker__chip-remove"
          (click)="removeAssignee(assignee, $event)"
          title="Retirer"
        >
          <i class="pi pi-times"></i>
        </button>
      </span>
    </div>

    <!-- Placeholder -->
    <span class="task-assignee-picker__placeholder" *ngIf="assignees.length === 0">
      {{ placeholder }}
    </span>

    <!-- Chevron -->
    <i
      class="pi pi-chevron-down task-assignee-picker__chevron"
      [class.task-assignee-picker__chevron--open]="isOpen"
    ></i>
  </div>

  <!-- Overlay pour fermer au clic extérieur -->
  <div class="task-assignee-picker__overlay" *ngIf="isOpen" (click)="close()"></div>

  <!-- Dropdown -->
  <div class="task-assignee-picker__dropdown" *ngIf="isOpen">
    <!-- Recherche -->
    <div class="task-assignee-picker__search">
      <i class="pi pi-search"></i>
      <input
        #searchInput
        type="text"
        [(ngModel)]="searchTerm"
        (input)="onSearchInput()"
        (keydown.enter)="selectFirstMatch($event)"
        placeholder="Rechercher..."
        class="task-assignee-picker__search-input"
      />
    </div>

    <!-- Assignés actuels -->
    <div class="task-assignee-picker__section" *ngIf="assignees.length > 0">
      <div class="task-assignee-picker__section-title">Assignés</div>
      <div *ngFor="let assignee of assignees" class="task-assignee-picker__item task-assignee-picker__item--selected">
        <span class="task-assignee-picker__item-avatar" [style.background-color]="assignee.badge_color || '#BEBEBE'">
          {{ assignee.initials || getInitials(assignee.name) }}
        </span>
        <span class="task-assignee-picker__item-name">{{ assignee.name }}</span>
        <button type="button" class="task-assignee-picker__item-remove" (click)="removeAssignee(assignee, $event)">
          <i class="pi pi-times"></i>
        </button>
      </div>
    </div>

    <!-- Suggestions -->
    <div class="task-assignee-picker__section" *ngIf="filteredEmployees.length > 0">
      <div class="task-assignee-picker__section-title" *ngIf="assignees.length > 0">Suggestions</div>
      <button
        type="button"
        *ngFor="let employee of filteredEmployees"
        class="task-assignee-picker__item"
        (click)="selectAssignee(employee)"
      >
        <span class="task-assignee-picker__item-avatar" [style.background-color]="employee.badge_color || '#BEBEBE'">
          {{ employee.initials || getInitials(employee.name) }}
        </span>
        <span class="task-assignee-picker__item-name">{{ employee.name }}</span>
      </button>
    </div>

    <!-- Aucun résultat -->
    <div class="task-assignee-picker__empty" *ngIf="filteredEmployees.length === 0 && searchTerm">
      <i class="pi pi-search"></i>
      <span>Aucun résultat pour "{{ searchTerm }}"</span>
    </div>

    <!-- Tous assignés -->
    <div
      class="task-assignee-picker__empty"
      *ngIf="filteredEmployees.length === 0 && !searchTerm && assignees.length >= employees.length"
    >
      <i class="pi pi-check-circle"></i>
      <span>Tous les collaborateurs sont assignés</span>
    </div>
  </div>
</div>
